import { render, staticRenderFns } from "./xiaobai.vue?vue&type=template&id=d4e8a282&scoped=true&"
import script from "./xiaobai.vue?vue&type=script&lang=js&"
export * from "./xiaobai.vue?vue&type=script&lang=js&"
import style0 from "./xiaobai.vue?vue&type=style&index=0&id=d4e8a282&prod&rel=stylesheet%2Fscss&scoped=true&lang=scss&"
import style1 from "./xiaobai.vue?vue&type=style&index=1&id=d4e8a282&prod&rel=stylesheet%2Fscss&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4e8a282",
  null
  
)

export default component.exports